import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, map } from 'rxjs';
import { PaginatedRepository, REG_HUB_COMMON_CONFIG, RegHubCommonConfig, OrderListItem } from 'reg-hub-common';

@Injectable({
  providedIn: 'root'
})
export class OrderListRepositoryService extends PaginatedRepository<OrderListItem> {
  protected override _baseLink: string;

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(http, messageService);

    this._baseLink = `${config.rootUrl}/Orders`;
    this._customHeaders = new HttpHeaders()
      .set('Accept', 'application/vnd.reghub.list-item+json');
  }

  public getTopTenDraftOrders(userGroupID?: string, userID?: string): Observable<{ total: number, resource: OrderListItem[] }> {
    return this.getTopTenOrders({ states: ['draft', 'historicalDraft'], isChildSearch: false, userGroupID, userID });
  }

  public getTopTenPendingAndExceptionOrders(userGroupID?: string, userID?: string): Observable<{ total: number, resource: OrderListItem[] }> {
    return this.getTopTenOrders({ states: ['pending', 'awaitinghighvolumeresults', 'exception', 'registryoutage', 'outofregistryhours'], isChildSearch: false, userGroupID, userID });
  }

  public getTopTenInvalidOrders(userGroupID?: string, userID?: string): Observable<{ total: number, resource: OrderListItem[] }> {
    return this.getTopTenOrders({ states: ['invalid'], isChildSearch: false, userGroupID, userID });
  }

  public getTopTenCompleteOrders(userGroupID?: string, userID?: string): Observable<{ total: number, resource: OrderListItem[] }> {
    return this.getTopTenOrders({ states: ['complete', 'cancelled'], isChildSearch: false, userGroupID, userID, sortColumn: 'OrderStatusUpdatedDate' });
  }

  private getTopTenOrders(options: {
    states: string[],
    isChildSearch?: boolean,
    userGroupID?: string,
    userID?: string,
    sortColumn?: string
  }): Observable<{ total: number, resource: OrderListItem[] }> {
    let params = new HttpParams()
      .set('isVisible', true)
      .set('sortColumn', options.sortColumn ?? 'added')
      .set('sortDirection', 'desc')
      .set('pageSize', 10)
      .set('pageNumber', 1);

    if (options.isChildSearch !== undefined) {
      params = params.set('isChildSearch', options.isChildSearch);
    }

    if (options.userGroupID) {
      params = params.append('userGroupID', options.userGroupID);
    }

    if (options.userID) {
      params = params.append('userID', options.userID);
    }

    for (const state of options.states) {
      params = params.append('status', state);
    }

    return this.http.get<OrderListItem[]>(this._baseLink, this.buildGetOptions(params)).pipe(
      map(response => ({
        total: this.parseResourceCountHeader(response.headers),
        resource: response.body ?? []
      }))
    );
  }
}
